import React, { Component } from "react";
import { AmplifyAuthenticator, AmplifyConfirmSignIn, AmplifySignUp, AmplifySignOut } from '@aws-amplify/ui-react';


export default class Signin extends Component {

  constructor(props) {
    super(props);      
    this.handleChange = this.handleChange.bind(this);

    console.log("LOAD SIGN IN");

    }

    handleChange(event, {name, value}) { 
        this.setState({ [name]: value });
        this.props.searchTerm.term = value;
      }

      
      render() {
        return(       
            <>
            <div className="full-bg">

            <div style={{display:"inline-block",  backgroundColor:"white", zIndex:"100", height:"100vh", minWidth:"460px", paddingTop:"70px"}}>
            
            <img src="/images/icons/icon.png" style={{width:"60px"}}/>

            <p style={{paddingTop:"20px", fontSize:"26px", margin:"0px"}}>Try Inventory Shark For <span>Free</span>!</p>
            <p style={{color:"#aaa", padding:"50px", margin:"0px",paddingBottom:"10px", fontSize:"18px"}}>Start your 30 day trial and manage your Amazon business today!</p>
            <>


        {/*
        
        <button onClick={() => Auth.federatedSignIn({provider: 'Facebook'})}>Open Facebook</button>
        <button onClick={() => Auth.federatedSignIn({provider: 'Google'})}>Open Google</button>
        <button onClick={() => Auth.federatedSignIn()}>Open Hosted UI</button>
        <button onClick={() => Auth.signOut()}>Sign Out {user.getUsername()}</button> */}

            </>
            
            {/* <AmplifyAuthenticator federated={federated} /> */}
            
            {/* <AmplifySignUp usernameAlias="email" headerText="" slot="sign-up" ></AmplifySignUp>  */}

            <AmplifyAuthenticator>

            <AmplifySignOut buttonText="Sign Out"></AmplifySignOut>

            </AmplifyAuthenticator>

            <p style={{padding:"50px"}}> Have an existing Amazon.com Account? Sign in to create your account.</p>
            
            </div>
            <a href="https://aws.amazon.com/what-is-cloud-computing"><img src="https://d0.awsstatic.com/logos/powered-by-aws.png" alt="Powered by AWS Cloud Computing"/></a>

            </div>

             {/* <AmplifyConfirmSignIn headerText="Inventory shark sign up" slot="confirm-sign-up">

            </AmplifyConfirmSignIn> */}



            </>
            
        );
      }

    }
